import React from "react";
import { render } from 'react-dom';
import { ShuffleSlides2 } from './shuffleSlides2';

(function init() {
  const selectors = {
    root: '[data-swiper-2]'
  }

  const rootElement = document.querySelector(selectors.root);

  if (!rootElement) return;

  render(<Carousel />, rootElement)
})();

function Carousel() {
  return (
    <>
    <h2 className="text-center pb-5">Best Sellers</h2>
    <ShuffleSlides2 />
    </>
  );
}